import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getCopResolution = api(async function copResolution({ id }) {
    return query(
        gql`
            query GetCopResolution($id: ID!) {
                copResolution(id: $id)
            }
        `,
        { id },
        { returns: "copResolution" }
    )
})
